<template>
    <div
        v-if="showPromotion && data?.showBadge && data?.title"
        class="absolute flex flex-col items-end right-2.5 gap-2 top-6 z-20 text-xs"
    >
        <div class="badge badge-sale rounded-none">
            {{ data.title }}
        </div>

        <div
            v-if="data.validUntil || data.code"
            role="button"
            tabindex="0"
            class="relative flex flex-col items-center bg-secondary-content text-secondary py-1 px-4 leading-3 gap-1"
            :class="{ 'cursor-pointer': data.code && isSupported }"
            @click="handleCodeClick"
            @keydown.enter="handleCodeClick"
        >
            <div
                class="absolute -top-[7px] right-0 -translate-x-1/2 w-0 h-0
                border-l-8 border-r-8 border-b-8
                border-l-transparent border-r-transparent border-b-secondary-content"
            />

            <div v-if="data.validUntil">
                {{ $t('product.detail.promotionBadgeCountdown') }}:
                <MiscCountdown :target-date="data.validUntil" />
            </div>

            <div v-if="data.code" class="flex gap-1 items-center">
                {{ $t('product.detail.promotionBadgeCode') }}:
                <span class="font-bold">{{ data.code }}</span>
                <span v-if="!copied">
                    <MiscIcon name="clipboard" size="sm" />
                </span>
                <span v-else>
                    <MiscIcon name="check" size="sm" />
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import { useClipboard } from '@vueuse/core'

let detailPromotionData = inject<Ref>('detailPromotionData')
const { 
    showPromotion, 
    computedPromotionData: data, 
    fetchPromotionData 
} = useDetailPromotion(detailPromotionData)
const { copy, copied, isSupported } = useClipboard()

const handleCodeClick = () => {
    if (data?.value?.code && isSupported.value) {
        copy(data.value.code)
    }
}

useRuntimeHook('productVariantChanged', onVariantChanged)

async function onVariantChanged ({ data }: { data: Schemas['Product'] }) {
    const detailPromotionResponse = await fetchPromotionData(data.id)

    if (detailPromotionResponse != null && detailPromotionResponse.total > 0) {
        detailPromotionData = ref(detailPromotionResponse.elements)
    }
}
</script>
